webpackJsonp([24],{

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(772),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SubTabs',
  props: {
    tabs: {
      type: Array,
      default: null
    },
    nomeSessao: String
  },
  data: function data() {
    return {
      rotaAtual: ''
    };
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loadingMounted;
    },
    rota: function rota() {
      var rota = this.$store.state.route.path;
      rota = rota.split('/');
      return '/Painel/' + rota[2] + '/';
    },
    caminho: function caminho() {
      return this.$store.state.route.path;
    }
  }
});

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".sub-tab .v-tabs__container{background-color:#eaedf4!important}.sub-tab li a{font-weight:600;color:#5f6670!important}.sub-tab .tabs__item.tabs__item--active{color:#0063bb!important}.sub-tab .tabs__slider.accent{background-color:#0063bb!important;border-color:#0063bb!important}.no-transform,.sub-tab .tabs__item{text-transform:none!important}.not-avaliable a{cursor:default!important}.sub-tab .tabs__bar{background-color:transparent}.top-blur{position:fixed;left:0;bottom:0;right:0;top:0;z-index:1}.confirmado.top-blur{opacity:0;visibility:hidden;-webkit-transition:opacity .7s,visibility 1s;transition:opacity .7s,visibility 1s}.blur{-webkit-filter:blur(1px);filter:blur(1px)}.confirmado.blur{-webkit-filter:blur(0);filter:blur(0);-webkit-transition:-webkit-filter .1s;transition:-webkit-filter .1s;transition:filter .1s;transition:filter .1s,-webkit-filter .1s}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/SubTabs.vue"],"names":[],"mappings":"AACA,4BACC,kCAAqC,CACrC,AACD,cACE,gBAAiB,AACjB,uBAAwB,CACzB,AACD,wCACE,uBAA0B,CAC3B,AACD,8BACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,6BAA+B,CAChC,AACD,iBACE,wBAA0B,CAC3B,AACD,oBACE,4BAA8B,CAC/B,AAED,UACE,eAAgB,AAChB,OAAQ,AACR,SAAU,AACV,QAAS,AACT,MAAQ,AACR,SAAW,CACZ,AACD,qBACE,UAAW,AACX,kBAAmB,AACnB,6CAAgD,AAChD,oCAAwC,CACzC,AACD,MACM,yBAA0B,AAClB,gBAAkB,CAC/B,AACD,iBACE,uBAA0B,AAClB,eAAkB,AAC1B,sCAAwC,AACxC,8BAAgC,AAChC,sBAAwB,AACxB,wCAA6C,CAC9C","file":"SubTabs.vue","sourcesContent":["\n.sub-tab .v-tabs__container {\n background-color: #eaedf4 !important;\n}\n.sub-tab li a{\n  font-weight: 600;\n  color: #5f6670!important\n}\n.sub-tab .tabs__item.tabs__item--active{\n  color: #0063bb !important;\n}\n.sub-tab .tabs__slider.accent{\n  background-color: #0063bb !important;\n  border-color: #0063bb !important;\n}\n.no-transform,.sub-tab .tabs__item{\n  text-transform: none!important;\n}\n.not-avaliable a{\n  cursor: default!important;\n}\n.sub-tab .tabs__bar{\n  background-color: transparent;\n}\n/*loading*/\n.top-blur{\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top:0px;\n  z-index: 1;\n}\n.confirmado.top-blur{\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: opacity 0.7s, visibility 1s;\n  transition: opacity 0.7s, visibility 1s;\n}\n.blur{\n      -webkit-filter: blur(1px);\n              filter: blur(1px);\n}\n.confirmado.blur{\n  -webkit-filter: blur(0px);\n          filter: blur(0px);\n  -webkit-transition: -webkit-filter 0.1s;\n  transition: -webkit-filter 0.1s;\n  transition: filter 0.1s;\n  transition: filter 0.1s, -webkit-filter 0.1s;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("736267a7", content, true, {});

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "sub-tab-color mb-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('v-tabs', {
    staticClass: "sub-tab",
    attrs: {
      "value": _vm.caminho,
      "slider-color": "blue"
    }
  }, _vm._l(((_vm.tabs !== null ? _vm.tabs : [])), function(tab) {
    return _c('v-tab', {
      key: _vm.rota + tab.url,
      attrs: {
        "ripple": false,
        "to": _vm.rota + tab.url
      }
    }, [_vm._v("\n          " + _vm._s(tab.nome) + "\n        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {}, [_vm._t("default"), _vm._v(" "), _c('router-view', {
    class: _vm.loading ? 'blur' : 'blur confirmado'
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_painel_SubTabs__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_painel_SubTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_painel_SubTabs__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PRelatorios',
  components: {
    'sub-tabs': __WEBPACK_IMPORTED_MODULE_0__components_painel_SubTabs___default.a
  },
  data: function data() {
    return {
      tabs: [
      // {
      //   nome: 'Itens mais solicitados',
      //   url: 'Itens'
      // },
      {
        nome: 'Pedidos',
        url: 'Condominios'
      }]
    };
  }
});

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('sub-tabs', {
    attrs: {
      "nomeSessao": "Relatórios",
      "tabs": _vm.tabs
    }
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.53d6d07a7c72370b0d20.js